import React, { useEffect, useState } from 'react';
import './addmodule.scss';
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import { useNavigate, useParams } from "react-router-dom";
import { notify } from '../../services/notification';
import { useDispatch, useSelector } from 'react-redux';
import { addModuleAction, editModuleAction, getModuleByIdAction, tutorialListAction, getVehiclesCategoryAction, getVehiclesByCategoryAction, tutorialListAction2, getUserTypeListAction, getTrainingCategoryAction, getTypeMasterListAction } from '../../actions/trainingModuleAction';
import { HTTP_STATUS } from '../../constants/httpsStatus/httpsStatus';
import {
    FormControl,
    InputLabel,
    Select as MuiSelect,
    Checkbox,
    ListItemText,
    MenuItem,
} from "@mui/material";
import { calculatePageCount, constant, ALLOWED_2W_CONTENT_TYPES, pgmThreeWheelerConstant } from "../../constants/constant";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import NoDataFound from '../../component/noDataComponent/NoDataFound';
import AddModuleSkeleton from '../../component/SkeletonLoader/AddModuleSkeleton';
import AddModuleTableSkeleton from '../../component/SkeletonLoader/AddModuleTableSkeleton';
import useMobileView from "../../constants/useMobileView";
import { is2w } from '../../constants/vehicleTypeHelper';

const AddModule = () => {
  const twoW = is2w();

  const [tutorialList, SettutorialList] = useState([]);
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const [fileName, setFileName] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectionCache, setSelectionCache] = useState({});
  const [description, setDescription] = useState('');
  const [name, setName] = useState('');
  const [filteredModules, setFilteredModules] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [count, setCount] = useState(1);
  const [vehicles, setVehicles] = useState([]);
  const [page, setPage] = useState(1);
  const [paginationListcount, setpaginationListcount] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [type, setSelectedType] = useState('');
  const [attachmentTypes, setAttachmentTypes] = useState(['Video', 'Pdf']);

  const [selectedFileType, setSelectedFileType] = useState('');
  const [vehicleCategory, setVehicleCategory] = useState(twoW ? '' : '2');
  const [searchQuery, setSearchQuery] = useState("");

  // 2W-specific state
  const [category, setCategory] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [contentTypeOptions, setContentTypeOptions] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
  const [selectedUserTypes, setSelectedUserTypes] = useState([]);
  // Holds the category name from API until categoryOptions are loaded
  const [pendingCategoryName, setPendingCategoryName] = useState(null);

  const [filters, setFilters] = useState({
    type: '',
    fileTypes: [],
    vehicleCategory: '',
    vehicle: '',
    searchQuery: ''
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  // Route paths
  const moduleListPath = twoW ? '/2w/training/modules/list' : '/training/modules/list';

  const fetchTutorialList = async () => {
    setIsLoading(true);

    const searchParam = searchQuery || '';
    const typeParam = type || '';
    const vehicleParam = selectedVehicle || '';
    const filetypeParam = (selectedFileType || '')?.toLowerCase();
    const trainingCategoryId = twoW ? (category || '') : '';
    const userTypeIds = twoW ? selectedUserTypes : [];

    const response = await dispatch(tutorialListAction2(typeParam, vehicleParam, searchParam, page, filetypeParam, trainingCategoryId, userTypeIds));

    if (response?.status === HTTP_STATUS.SUCCESS) {
      let tutorials = response?.data?.data?.results || [];
      SettutorialList(tutorials);
      setFilteredModules(tutorials);
      setpaginationListcount(response.data.data.count);
      const totalPageCount = calculatePageCount(response.data.data.count, constant.paginationCount);
      setCount(totalPageCount);
    }

    setIsLoading(false);
  };

  const selectedUserTypesKey = selectedUserTypes.join(',');

  useEffect(() => {
    fetchTutorialList();
  }, [type, selectedVehicle, selectedFileType, page, ...(twoW ? [category, selectedUserTypesKey] : [])]);

  const { modules, error } = useSelector(state => state.addModuleReducer || {});

  useEffect(() => {
    const fetchInitData = async () => {
      try {
        const [utResp, ctResp] = await Promise.all([
          dispatch(getUserTypeListAction()),
          dispatch(getTypeMasterListAction()),
          ...(twoW ? [dispatch(getTrainingCategoryAction())] : []),
        ]);

        if (utResp?.status === HTTP_STATUS.SUCCESS) {
          const list = utResp.data?.data?.results || utResp.data?.data || [];
          setUserTypes(list);
          if (!twoW) {
            const threeWEntry = list.find(ut => ut?.slug === 'pgm_3w');
            if (threeWEntry) setSelectedUserTypes([threeWEntry.id]);
          }
        }
        if (ctResp?.status === HTTP_STATUS.SUCCESS && ctResp?.data?.success) {
          setContentTypeOptions((ctResp.data.data || []).map(t => ({ value: t.slug, label: t.display_name })));
        }
      } catch (err) {
        notify.error('Failed to load form data');
      }
    };

    const fetchTrainingCategories = async () => {
      try {
        const response = await dispatch(getTrainingCategoryAction());
        if (response?.status === HTTP_STATUS.SUCCESS && response?.data?.success) {
          setCategoryOptions((response.data.data || []).map(cat => ({ value: cat.id, label: cat.display_name })));
        }
      } catch (error) {
        notify.error('Failed to load training categories');
      }
    };

    fetchInitData();
    if (twoW) fetchTrainingCategories();
  }, []);

  useEffect(() => {
    if (id) {
      setIsEditing(true);
      setPageLoading(true);
      dispatch(getModuleByIdAction(id))
        .then((response) => {
          const moduleToEdit = response?.data?.data;
          if (moduleToEdit) {
            setName(moduleToEdit.name);
            setDescription(moduleToEdit.description);
            setSelectedType(moduleToEdit.type);
            const loadedItemIds = moduleToEdit.training_list.map((item) => item.id);
            setSelectedItems(loadedItemIds);
            if (twoW) {
              if (moduleToEdit.training_category_id) {
                setCategory(moduleToEdit.training_category_id);
                setSelectionCache(prev => ({ ...prev, [moduleToEdit.training_category_id]: loadedItemIds }));
              } else if (moduleToEdit.training_category) {
                setPendingCategoryName(moduleToEdit.training_category);
              }
              const userTypeIds = moduleToEdit.User_type_ids || moduleToEdit.user_type_ids || [];
              if (userTypeIds.length) {
                setSelectedUserTypes(userTypeIds);
              }
            }
          }
        })
        .finally(() => { setIsEditing(false); setPageLoading(false); });
    }
  }, [id]);

  // Resolve category name → ID once categoryOptions are available (edit mode)
  useEffect(() => {
    if (pendingCategoryName && categoryOptions.length > 0) {
      const matched = categoryOptions.find(opt => opt.label === pendingCategoryName);
      if (matched) {
        setCategory(matched.value);
        setSelectionCache(prev => ({ ...prev, [matched.value]: selectedItems }));
      }
      setPendingCategoryName(null);
    }
  }, [pendingCategoryName, categoryOptions]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(filteredData?.map(item => item.id) || []);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (itemId) => {
    setSelectedItems((prev) =>
      prev.includes(itemId) ? prev.filter((item) => item !== itemId) : [...prev, itemId]
    );
  };

const handleRemoveItem = (itemId) => {
    setSelectedItems((prev) => prev.filter((item) => item !== itemId));
  };

  // 2W: exclude pgm_3w; 3W: only pgm_3w
  const visibleUserTypes = twoW
    ? userTypes.filter(ut => ut?.slug !== pgmThreeWheelerConstant.pgmThreeWheeler)
    : userTypes.filter(ut => ut?.slug === pgmThreeWheelerConstant.pgmThreeWheeler);

  const handleUserTypeChange = (e) => {
    const value = e.target.value;
    if (value.includes("all")) {
      setSelectedUserTypes(
        value.length === visibleUserTypes.length + 1 ? [] : visibleUserTypes.map(ut => ut.id)
      );
    } else {
      setSelectedUserTypes(value);
    }
    setPage(1);
  };

  const handleSave = async () => {
    if (twoW) {
      if (!name || !category || selectedItems?.length === 0 || !selectedUserTypes?.length) {
        notify.error('Please fill all required fields and select at least one content item');
        return;
      }
    } else {
      if (!name || selectedItems?.length === 0) {
        notify.error('Please provide a name and select at least one module');
        return;
      }
    }

    setIsSaving(true);
    const training_ids = selectedItems;
    const dataToSave = {
      name,
      description,
      type,
      training_ids,
      user_type_ids: selectedUserTypes,
      training_category_id: twoW ?  category : selectedUserTypes?.[0]
    };

    if (id) {
      try {
        const response = await dispatch(editModuleAction(id, dataToSave));
        if (response?.status === HTTP_STATUS.SUCCESS || response?.status === HTTP_STATUS.CREATED) {
          notify.success(response?.data?.message);
          navigate(moduleListPath);
        } else {
          notify.error('Failed to update module');
        }
      } catch (error) {
        notify.error('Failed to update module');
      } finally {
        setIsSaving(false);
      }
    } else {
      try {
        const response = await dispatch(addModuleAction(dataToSave));
        if (response?.status === HTTP_STATUS.SUCCESS || response?.status === HTTP_STATUS.CREATED) {
          notify.success(response?.data?.message);
          navigate(moduleListPath);
        } else {
          notify.error('Failed to save module');
        }
      } catch (error) {
        notify.error('Failed to save module');
      } finally {
        setIsSaving(false);
      }
    }
  };

  const handleTypeChange = (e) => {
    const type = e.target.value || '';
    setSelectedFileType('');
    setSelectedType(type);
    const filteredTutorials = tutorialList?.filter(
      (tutorial) => !type || tutorial.type === type
    );

    setSelectedItems([]);
    setFilteredModules(filteredTutorials);
    setPage(1);
    setCount(calculatePageCount(filteredTutorials?.length, constant.paginationCount));
    setpaginationListcount(filteredTutorials?.length || 0);
  };

  const filteredData = searchQuery
    ? filteredModules?.filter((item) =>
      item?.title?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : filteredModules;

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".dropdown-container")) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const [vehicleCategories, setVehicleCategories] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const fetchvehicles = async (categoryId) => {
    try {
      const response = await dispatch(getVehiclesByCategoryAction(categoryId));
      if (response?.status === HTTP_STATUS.SUCCESS) {
        setVehicles(response.data.data.results || []);
      }
    } catch (error) {
      notify.error("Error fetching vehicles for category:", error);
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await dispatch(getVehiclesCategoryAction());
        if (response?.status === HTTP_STATUS.SUCCESS) {
          setVehicleCategories(response.data?.data?.results || []);
        }
      } catch (error) {
        notify.error("Error fetching vehicle categories:", error);
      }
    };

    fetchCategories();
    if (!twoW) {
      const selectedCategoryId = 2;
      fetchvehicles(selectedCategoryId);
    }
  }, [dispatch]);

  const handleCategoryChange = async (categoryId) => {
    setVehicleCategory(categoryId);
    setSelectedVehicle([]);
    if (twoW && categoryId) {
      fetchvehicles(categoryId);
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const [tutorials, setTutorials] = useState([]);
  const [filteredTutorials, setFilteredTutorials] = useState([]);

  const handleSearch = () => {
    if (searchQuery.length >= 3) {
      const filtered = tutorialList.filter((tutorial) =>
        tutorial.title?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredModules(filtered);
    } else {
      setFilteredModules(tutorialList);
    }
  };

  useEffect(() => {
    if (!twoW) {
      if (searchQuery?.length >= 1) {
        const filtered = tutorialList.filter((tutorial) =>
          tutorial.moduleName?.includes(searchQuery?.toLowerCase())
        );
        setFilteredTutorials(filtered);
      } else {
        setFilteredTutorials(tutorialList);
      }
    }
  }, [searchQuery, tutorialList]);

  const handleFileTypeChange = (e) => {
    const value = e.target.value;
    if (type) setSelectedFileType(value);
  };

  // 3W: apply filters
  useEffect(() => {
    if (twoW) return;
    let filteredDataLocal = [...tutorialList];
    if (selectedFileType.length) {
      filteredDataLocal = filteredDataLocal.filter((tutorial) =>
        selectedFileType.includes(tutorial.attachment_type)
      );
    }
    if (vehicleCategory) {
      filteredDataLocal = filteredDataLocal.filter(
        (tutorial) => tutorial.vehicleCategory === vehicleCategory
      );
    }
    if (selectedVehicle) {
      filteredDataLocal = filteredDataLocal.filter((tutorial) =>
        tutorial.vehicle_list.some(
          (vehicle) => vehicle.vehicle_id === selectedVehicle
        )
      );
    }
    if (searchQuery) {
      filteredDataLocal = filteredDataLocal.filter((tutorial) =>
        tutorial.moduleName?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    setFilteredTutorials(filteredDataLocal);
  }, [selectedFileType, vehicleCategory, selectedVehicle, searchQuery]);

  return (
    <div className={twoW ? 'training-add-module-2w' : 'training-add-module'}>
      <div className="tutorial-page-container">
        <div className="tutorial-content-wrapper">
          <Header title={id ? "Edit Module" : "Add Module"} />

          {pageLoading ? (
            <div className="tutorial-section">
              <AddModuleSkeleton />
            </div>
          ) : (
          <div className="tutorial-section">
            <div className="tutorial-panel">

              <div className='wrap-search-add-content'>
                <div className="tutorial-filters">
                  <div className='module-name-description-input'>
                    <div className="form-group-module">
                      <label className="form-label">Module Name</label>
                      <input
                        type="text"
                        className='add-module-input-field-name'
                        placeholder="Module Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="form-group-module">
                      <label className="form-label">Description</label>
                      <input
                        className="add-module-input-field-name"
                        placeholder="Enter description here..."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                  </div>

                  {twoW ? (
                    <>
                      <div className='module-name-description-input'>
                        <div className="form-group-module">
                          <label className="form-label">Category</label>
                          <select
                            className="form-select-dropdown"
                            value={category}
                            onChange={(e) => {
                              const newCategory = e.target.value;
                              setSelectionCache(prev => ({ ...prev, [category]: selectedItems }));
                              setSelectedItems(selectionCache[newCategory] || []);
                              setCategory(newCategory);
                              setPage(1);
                            }}
                            required
                          >
                            <option value="">Select Category</option>
                            {categoryOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group-module">
                          <label className="form-label">
                            Select Type <span style={{ color: 'red' }}>*</span>
                          </label>
                          <select
                            className="form-select-dropdown"
                            value={type}
                            onChange={handleTypeChange}
                          >
                            <option value="">Select Type</option>
                            {contentTypeOptions.filter(opt => ALLOWED_2W_CONTENT_TYPES.includes(opt.value)).map((opt) => (
                              <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='module-name-description-input'>
                        <div className="form-group-module">
                          <label className="form-label">User Type</label>
                          <FormControl className="multiselect_part_module" fullWidth>
                            <MuiSelect
                              className='multi-select-box'
                              multiple
                              value={selectedUserTypes}
                              onChange={handleUserTypeChange}
                              renderValue={(selected) =>
                                visibleUserTypes
                                  .filter((ut) => selected.includes(ut?.id))
                                  .map((ut) => ut?.user_type)
                                  .join(", ")
                              }
                            >
                              {visibleUserTypes?.length > 0 && (
                                <MenuItem value="all">
                                  <Checkbox checked={selectedUserTypes?.length === visibleUserTypes?.length} />
                                  <ListItemText primary="Select All" />
                                </MenuItem>
                              )}
                              {visibleUserTypes?.map((ut) => (
                                <MenuItem key={ut?.id} value={ut?.id}>
                                  <Checkbox checked={selectedUserTypes.includes(ut?.id)} />
                                  <ListItemText primary={ut?.user_type} />
                                </MenuItem>
                              ))}
                            </MuiSelect>
                          </FormControl>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className='module-name-description-input'>
                      <div className="form-group-module">
                        <label className="form-label">Select Type</label>
                        <select
                          className="form-select-dropdown"
                          value={type}
                          onChange={handleTypeChange}
                        >
                          <option value="">Select Type</option>
                          {contentTypeOptions.filter(opt => ['training', 'trouble_shooting'].includes(opt.value)).map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group-module">
                        <label className="form-label">User Type</label>
                        <FormControl className="multiselect_part_module" fullWidth>
                          <MuiSelect
                            className='multi-select-box'
                            multiple
                            value={selectedUserTypes}
                            onChange={undefined}
                            disabled
                            renderValue={(selected) =>
                              visibleUserTypes
                                .filter((ut) => selected.includes(ut?.id))
                                .map((ut) => ut?.user_type)
                                .join(", ")
                            }
                          >
                            {visibleUserTypes?.map((ut) => (
                              <MenuItem key={ut?.id} value={ut?.id}>
                                <Checkbox checked={selectedUserTypes.includes(ut?.id)} />
                                <ListItemText primary={ut?.user_type} />
                              </MenuItem>
                            ))}
                          </MuiSelect>
                        </FormControl>
                      </div>
                    </div>
                  )}
                </div>

                <div className='create-module-search-filter'>
                  <div className="form-group-search-filetype">
                    {attachmentTypes.length ? (
                      <div className="dropdown-options">
                        {attachmentTypes.map((type) => (
                          <label key={type} className="dropdown-option">
                            <input
                              className='radio-filetype-input'
                              type="radio"
                              name="file-type"
                              value={type}
                              checked={selectedFileType === type}
                              onChange={handleFileTypeChange}
                            />
                            {type}
                          </label>
                        ))}
                      </div>
                    ) : <></>}
                  </div>
                  <div className="form-group-search-vehicle-category">
                    <select
                      id="vehicleCategory"
                      className="add-module-input-field-name"
                      value={vehicleCategory}
                      onChange={(e) => handleCategoryChange(e.target.value)}
                      disabled={!twoW}
                    >
                      <option value="">Select Vehicle Category</option>
                      {Array.isArray(vehicleCategories) && vehicleCategories.length > 0 ? (
                        vehicleCategories.map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.name}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          No categories available
                        </option>
                      )}
                    </select>
                  </div>
                  <div className="form-group-search-select-vehicle">
                    <select
                      id="vehicles"
                      className="add-module-input-field-name"
                      value={selectedVehicle}
                      onChange={(e) => setSelectedVehicle(e.target.value)}
                    >
                      <option value="">Select Vehicle</option>
                      {Array.isArray(vehicles) && vehicles.length > 0 ? (
                        vehicles.map((vehicle) => (
                          <option key={vehicle.id} value={vehicle.id}>
                            {vehicle.name}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          No vehicles available
                        </option>
                      )}
                    </select>
                  </div>
                  <div className="search-input-field">
                    <input
                      type="text"
                      name="searchQuery"
                      placeholder="Search by Title"
                      className="tutorial-search-inputs"
                      value={searchQuery}
                      onChange={handleSearchInputChange}
                    />
                    <button
                      className="tutorial-search-btn"
                      onClick={handleSearch}
                      disabled={searchQuery?.length > 0 && searchQuery?.length < 3}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>

              {isLoading ? (
                <AddModuleTableSkeleton rows={5} />
              ) : (
                <div className="tutorial-table-container">
                  <div className='tutorial-table-data'>
                    <table className="table">
                      <thead>
                        <tr className="tablesth">
                          <th>
                            <label className="tutorial-checkbox-label">
                              <input
                                type="checkbox"
                                checked={selectedItems.length === filteredData?.length}
                                onChange={handleSelectAll}
                              />
                            </label>
                          </th>
                          <th>Thumbnail</th>
                          <th>{twoW ? 'Title' : 'Tutorial Title'}</th>
                          <th>Description</th>
                          <th>File Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData?.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <label className="tutorial-checkbox-label">
                                <input
                                  type="checkbox"
                                  checked={selectedItems.includes(item.id)}
                                  onChange={() => handleSelectItem(item.id)}
                                />
                              </label>
                            </td>
                            <td>
                              {item.attachment_type == "PDF" ?
                                <img
                                  src={Image_Url.PDF}
                                  alt={`Thumbnail ${item.id}`}
                                  style={{ width: "100px", height: "100px" }}
                                />
                                :
                                <img
                                  src={Image_Url.THUMBNAILS}
                                  alt={`Thumbnail ${item.id}`}
                                  style={{ width: "100px", height: "100px" }}
                                />
                              }
                            </td>
                            <td>{item.title}</td>
                            <td className='add-module-long-text' title={item?.description}>{item.description}</td>
                            <td>{item.attachment_type}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {filteredData?.length === 0 && <NoDataFound />}
                </div>
              )}
              {filteredData?.length === 0 ? ""
                : <div className="Pagination_section">
                  <Stack spacing={2}>
                    <Pagination
                      count={count}
                      page={page}
                      size="medium"
                      defaultPage={1}
                      color="primary"
                      onChange={handlePaginationChange}
                    />
                  </Stack>
                </div>
              }

              <div className="tutorial-search">
                <button
                  className="tutorial-search-btn"
                  onClick={() => navigate(moduleListPath)}
                >
                  Close
                </button>
                <button
                  className="tutorial-search-btn"
                  onClick={handleSave}
                  disabled={isSaving || (twoW
                    ? (!name || !description || !category || !selectedUserTypes?.length)
                    : !description
                  )}
                >
                  {isSaving ? "Saving..." : id ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddModule;
